import { Intervention } from '@seen/core/models/care-plans/intervention'
import { type JSX, useMemo } from 'react'
import { ComboboxOption as ComboboxOptionComponent } from '#src/components/ComboboxOption.tsx'
import {
  Combobox,
  type ComboboxOption,
  type ComboboxProps,
} from '#src/components/core/combobox/Combobox.tsx'
import { IconInterventionStatus } from '#src/components/icons/IconInterventionStatus.tsx'
import { useIsReadOnly } from '#src/hooks/useIsReadOnly.ts'

interface InterventionStatusComboboxProps extends Omit<
  ComboboxProps<Intervention['status']>,
  'options'
> {
  selected: Intervention['status']
}

export function InterventionStatusCombobox({
  selected,
  disabled,
  ...delegated
}: InterventionStatusComboboxProps): JSX.Element {
  const isReadOnly = useIsReadOnly()
  const options: ComboboxOption<Intervention['status']>[] = useMemo(
    () => [
      {
        value: 'active',
        label: (
          <ComboboxOptionComponent isSelected={selected === 'active'}>
            <IconInterventionStatus status="active" />
            {Intervention.statusText('active')}
          </ComboboxOptionComponent>
        ),
        keywords: ['Active'],
      },
      {
        value: 'completed',
        label: (
          <ComboboxOptionComponent isSelected={selected === 'completed'}>
            <IconInterventionStatus status="completed" />
            {Intervention.statusText('completed')}
          </ComboboxOptionComponent>
        ),
        keywords: ['Completed'],
      },
      {
        value: 'revoked',
        label: (
          <ComboboxOptionComponent isSelected={selected === 'revoked'}>
            <IconInterventionStatus status="revoked" />
            {Intervention.statusText('revoked')}
          </ComboboxOptionComponent>
        ),
        keywords: ['Discontinued'],
      },
    ],
    [selected]
  )
  return (
    <Combobox
      options={options}
      disabled={disabled || isReadOnly}
      {...delegated}
    />
  )
}
